import { createSlice } from '@reduxjs/toolkit';

export interface IPriceState {
    isFilterOpen: boolean;
    favoriteItem: { id: number; isFavorite: boolean };
}

const initialState: IPriceState = {
    isFilterOpen: false,
    favoriteItem: { id: 0, isFavorite: false },
};

export const priceSlice = createSlice({
    name: 'priceSlice',
    initialState,
    reducers: {
        setIsFilterOpen: (state, action) => {
            state.isFilterOpen = action.payload;
        },
        setFavoriteItem: (state, action) => {
            state.favoriteItem = action.payload;
        },
    },
});

export const { setIsFilterOpen, setFavoriteItem } = priceSlice.actions;

export default priceSlice.reducer;
